// Build a compact place label from the city's first comma-separated part and the region.
// Empty or non-string values are omitted, including the separator between them.
export function placeText(city, region) {
  const cityText = typeof city === 'string' ? city.split(',')[0].trim() : '';
  const regionText = typeof region === 'string' ? region.trim() : '';
  return [cityText, regionText].filter(Boolean).join(', ');
}
